import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

export interface EditarEdducaiData {
  titulo: string;
  label: string;
  nomeAtual: string;
  maxLength?: number;
}

@Component({
  selector: 'app-editar-edducai',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  templateUrl: './editar-edducai.component.html',
  styleUrls: ['./editar-edducai.component.scss']
})
export class EditarEdducaiComponent {
  @ViewChild('nomeInput') nomeInput!: ElementRef<HTMLInputElement>;

  form: FormGroup;
  max = 20;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditarEdducaiComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) public data: EditarEdducaiData
  ) {
    this.max = data.maxLength ?? 20;
    this.form = this.fb.group({
      nome: [data.nomeAtual ?? '', [Validators.required, Validators.maxLength(this.max), this.noWhitespace]]
    });

    // Foco
    setTimeout(() => this.nomeInput?.nativeElement?.select(), 150);
  }

  cancelar(): void {
    this.dialogRef.close(null);
  }

  salvar(): void {
    if (this.form.invalid) return;
    const novo = (this.form.value.nome ?? '').trim();
    if (!novo) return;
    this.dialogRef.close(novo);
  }

  private noWhitespace = (control: any) => {
    const v = (control.value ?? '').toString();
    return v.trim().length ? null : { whitespace: true };
  };
}
